import { ref } from 'vue'
import { defineStore } from 'pinia'
import * as Cesium from 'cesium';

export type SelectedAsset = {
  feature: Cesium.Cesium3DTileFeature;
  tileset: Cesium.Cesium3DTileset;
  properties: Record<string, any>;
  coords: {
    lat: number;
    lng: number;
    height: number;
  };
};

const useDetailPanelStore = defineStore('detail-panel', () => {
  const selectedAsset = ref<SelectedAsset | null>(null);
  const selectedAssetPosition = ref<{ lat: number; lng: number } | null>(null)

  const observerPosition = ref({ lat: 0.0, lng: 0.0, height: 0.0 })
  const rotation = ref(0.0)
  const tilt = ref(0.0)
  const fov = ref(0)
  const availableImages = ref<{ imageUid: string; date: string }[] | null>([])
  const currentImageId = ref<string | null>(null)

  const isPanelDisplayed = ref(false)

  const openPanel = () => {
    isPanelDisplayed.value = true
  }

  const closePanel = () => {
    isPanelDisplayed.value = false

    if (selectedAsset.value) {
      clearSelectedAsset();
    }
  }

  function setObserverPosition(pos: { lat: any; lng: any; height: any }) {
    observerPosition.value = {
      lat: pos.lat,
      lng: pos.lng,
      height: pos.height ?? null,
    }
  }

  function setSelectedAssetPosition(pos: { lat: any; lng: any }) {
    selectedAssetPosition.value = {
      lat: pos.lat,
      lng: pos.lng,
    }
  }

  const setSelectedAsset = (asset: SelectedAsset) => {
    selectedAsset.value = asset
  }

  const clearSelectedAsset = () => {
    if (selectedAsset.value) {
      selectedAsset.value.feature.color = Cesium.Color.WHITE;
    }
    selectedAsset.value = null
    selectedAssetPosition.value = null
  }

  return {
    selectedAsset,
    selectedAssetPosition,
    observerPosition,
    rotation,
    tilt,
    fov,
    availableImages,
    currentImageId,
    isPanelDisplayed,
    openPanel,
    closePanel,
    setSelectedAsset,
    setObserverPosition,
    setSelectedAssetPosition,
    clearSelectedAsset
  }
})

export default useDetailPanelStore
